import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsfEnum } from "@/utils/indicatorsEsf";
import { ResumeIndicatorC1Data } from "@/services/esus/indicator/esf/c1/getResumeIndicatorC1";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsfC1ResumeProps = {
	resume: ResumeIndicatorC1Data;
};

export function IndicatorEsfC1Resume({ resume }: Readonly<IndicatorEsfC1ResumeProps>) {
	const indicatorPercentage = calculatePercentage(
		resume.totalScheduledAttendances,
		resume.totalAttendances
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de atendimentos"
					value={resume.totalAttendances.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de atendimentos"
							message="Quantidade de atendimentos realizados no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Total de atendimentos programados"
					value={resume.totalScheduledAttendances.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Total de atendimentos programados"
							message="Quantidade de atendimentos realizados no período com agendamento prévio"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Cidadãos atendidos"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalCitizens.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Cidadãos atendidos"
							message="Quantidade de cidadãos distintos com pelo menos 1 atendimento no período"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="% Demanda programada"
					value={`${indicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsfEnum.C1,
						indicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="% Demanda programada"
							message="Percentual de atendimentos realizados no período com agendamento prévio em relação ao total de atendimentos realizados"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
